"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.state = exports.getActiveWorkspaceId = exports.getActiveWorkspace = exports.getAll = void 0;
function getAll(s) {
    const list = [];
    s.workspaces.workspaces.forEach((w) => list.push(w));
    return list;
}
exports.getAll = getAll;
function getActiveWorkspace(s) {
    const workspaceId = s.workspaces.activeWorkspaceId;
    if (!workspaceId) {
        return;
    }
    return s.workspaces.workspaces.get(workspaceId);
}
exports.getActiveWorkspace = getActiveWorkspace;
function getActiveWorkspaceId(s) {
    return s.workspaces.activeWorkspaceId;
}
exports.getActiveWorkspaceId = getActiveWorkspaceId;
function state(s) {
    const { errorMessage, isProcessing } = s.workspaces;
    return { errorMessage, isProcessing };
}
exports.state = state;
//# sourceMappingURL=selectors.js.map